export default {
    listagem: {
        titulo_pagina: 'Lista de Loincs',
        novo: 'Crear Nuevo Loinc',
        table: {
            empty: 'No se encontró Loinc',
            nome: 'Nombre',
            propriedade: 'Propiedad',
            sistema: 'Sistema',
            ordem_observacao: 'Orden / Nota',
            nome_longo: 'Nombre largo',
            nome_curto: 'Nombre corto',
            nome_exibicao: 'Nombre de exibición',
            componente: 'Componente',
            tempo: 'Tiempo',
            escala: 'Escala',
            metodo: 'Método',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Crear Nuevo Loinc',
            editar: 'Editar Loinc'
        },
        fields: {
            loinc: {
                label: 'LOINC',
                description: 'Código de Registro del Examen'
            },
            nome_longo: {
                label: 'Nombre Largo',
                description: 'Loinc Nombre largo'
            },
            nome_curto: {
                label: 'Nombre Corto',
                description: 'Loinc Nombre Corto'
            },
            nome_exibicao: {
                label: 'Nombre de Exibición',
                description: 'Nombre para Mostrar de Loinc'
            },
            status: {
                label: 'Estado',
                description: 'Estado de Loinc'
            },
            ordem_obs: {
                label: 'Orden / Nota',
                description: 'Tipo de Loinc'
            },
            componente: {
                label: 'Componente',
                description: 'Componente Loinc'
            },
            propriedade: {
                label: 'Propiedad',
                description: 'Propiedad de Loinc'
            },
            tempo: {
                label: 'Tiempo',
                description: 'Tiempo de Loinc'
            },
            sistema: {
                label: 'Sistema',
                description: 'Sistema Loinc'
            },
            escala: {
                label: 'Escala',
                description: 'Escala de Loinc'
            },
            metodo: {
                label: 'Método',
                description: 'Método de Loinc'
            },
            botao_salvar : 'Guardar Loinc'
        },
        create: {
            success: 'Loinc Creado con Éxito!',
            error: 'Error al Crear Loinc!'
        },
        update: {
            success: 'Loinc editado con Éxito!',
            error: 'Error al Editar Loinc!'
        }
    },
    import: {
        csv: {
            titulo_pagina: 'Importar LOINC CSV',
            tabs: {
                arquivo: {
                    label: 'Seleccione el archivo',
                    escolha: 'Elija un archivo o suelte uno aquí...',
                    solte: 'Suelta aquí...',
                    selecionado: 'Archivo Seleccionado',
                    botao_carregar: 'Subir CSV',
                    carregando: 'Cargando archivo',
                    preparando: 'Preparando archivo',
                    enviando: 'Enviando archivo',
                },
                criados: {
                    label: 'Creado',
                    botao_todos: ''
                },
                atualizados: {
                    label: 'Actualizado',
                    botao_todos: ''
                }
            },
            lang: {
                titulo_pagina: 'Importar Idioma LOINC CSV',
            },
            erro: {
                carregar: 'Error al cargar CSV',
                processar: 'Error al procesar CSV',
                enviar: 'Error al enviar parte de CSV'
            }
        }
    }
}
